// client/src/components/AdList.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, Button, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles.css';

const AdList = () => {
  const [ads, setAds] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await axios.get('/api/ads');
        setAds(response.data);
      } catch (error) {
        console.error("Failed to fetch ads", error);
      }
    };
    fetchAds();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this ad?');
    if (confirmDelete) {
      try {
        const token = localStorage.getItem('token');
        await axios.delete(`/api/ads/${id}`, {
          headers: { 'Authorization': `Bearer ${token}` },
        });
        setAds(ads.filter(ad => ad._id !== id));
        alert('Ad deleted successfully!');
      } catch (error) {
        console.error(error);
        alert('Failed to delete ad');
      }
    }
  };

  return (
    <Row xs={1} md={2} lg={3} className="g-4">
      {ads.map(ad => (
        <Col key={ad._id} className="d-flex">
          <Card className="flex-fill">
            {ad.image && (
              <Card.Img variant="top" src={`/uploads/${ad.image}`} alt={ad.title} style={{ height: '200px', objectFit: 'cover' }} />
            )}
            <Card.Body>
              <Card.Title>{ad.title}</Card.Title>
              <Card.Text>{ad.content}</Card.Text>
              <Card.Text><strong>Price: ${ad.price}</strong></Card.Text>
              <Card.Text><small>Location: {ad.location}</small></Card.Text>
              
              {/* ONLY show buttons if user exists AND ad.seller exists AND their IDs match */}
              {user && ad.seller && user._id === ad.seller._id ? (
                <div className="mt-3">
                  <Link to={`/edit-ad/${ad._id}`}>
                    <Button variant="warning" className="me-2">Edit</Button>
                  </Link>
                  <Button variant="danger" onClick={() => handleDelete(ad._id)}>Delete</Button>
                </div>
              ) : null}
              
              {/* Show Seller's Avatar and Name */}
              <Card.Text className="mt-3 text-muted d-flex align-items-center">
                {ad.seller?.avatar && (
                  <Image 
                    src={`uploads/${ad.seller.avatar}`} 
                    roundedCircle 
                    width="30" 
                    height="30" 
                    className="me-2" 
                    style={{ objectFit: 'cover' }}
                  />
                )}
                <small>Posted by: {ad.seller?.login || 'Unknown User'}</small>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AdList;